var _image;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    enableBackground: "new 0 0 70 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 70,
    height: 70,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAMAAABG8BK2AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAP1BMVEWMUv+TXf+pff/Lsv7o 3f738/7////h0/7Tvf6wiP/FqP/w6P6aaP++nf+3k/+/nv/Gqf/Ms/6ic//ayP7Uv/8LtbhxAAAA AWJLR0QGYWa4fQAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAAd0SU1FB+YJBREhLJWkcDsAAAFgSURB VFjD7dddl4IgEAZgQRgwWMHy///WFTezlI8Zcu94r+p0es4AA2LXtbS0/H8Y74WEU6TSAwG5RYgt Rluc8pNBVmjEKD0U05cVXVYA9AW1IOoZcQqAyynWYBnJvp2Yv/gMgy4mW86AVwD4FWMCmJKMyv1N DZ9DFkkmvQuMZ8d1lEkmNZsTj/UDjVFuXxNXyUh/T04emlGHRbVAZ4Q/NZijM7HT0tAZcW52DnQm OMuhfHv7WdcwIHRox91hsop55uUcjzQa83JULfMwb46FWsbaN0fXMmrbjOrcNAQmdODqhMfk+WRE MmZdZf388Khllhr4ujo6NsFo5r5dLMK+GAnMZ5vu3xbn/OhJH6ICEhGRR49KMhMQkr5VcAqTvr4x iVdMl46/YkyUckz2IumwTOEaiVysqStkxihzSUHVU6wlZCzcuaTDKMtunjOQ9AynhAyzir16iIkT kJaWlur8AqNaK+IUQFuqAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTA5LTA1VDE1OjMzOjQ0KzAy OjAwri+CvAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMi0wOS0wNVQxNTozMzo0NCswMjowMN9yOgAA AAAASUVORK5CYII="
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/icon-avatar.009c81b9ca500ff1ac3c83ea71b52fa5.svg";
export { ForwardRef as ReactComponent };